export default __webpack_public_path__ + "static/media/commission.f6571583.svg";